var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { currencyFormat, useForceUpdate } from '../../../lib/misc.functions';
import { tjkBetSlipActionSubject, tjkBetSlipOptions, tjkBetSlipVisibleSubject, tjkFobBettingTypes, tjkFobHorseSelectionTypes, } from '../tjk.store';
import { clearTjkBetSlip, PlayTjkFobCoupon, setTjkBetSlipMultiply, setTjkUsePointBalance, updateBetCount, } from '../tjk.betslip.service';
import { tjkBetslipStore } from './tjk.betslip';
import { member } from '../../../store/login.store';
import { modalServiceSubject } from '../../../components/modal/modal';
import Trash from '../../../assets/feather/trash-2.svg';
import Save from '../../../assets/feather/save.svg';
import './tjk.betslip.css';
var _initWidth = window.innerWidth;
export var fobBetSlipToggle = _initWidth >= 986;
function getOddsForItem(item) {
    var _a;
    var fobTypeId = Number(item.bettingType.id);
    if (tjkFobHorseSelectionTypes.includes(fobTypeId))
        return '-';
    var horseNo = item.horse.no;
    var eventOdds = (_a = item.run) === null || _a === void 0 ? void 0 : _a.event_odds;
    if (!eventOdds)
        return '-';
    if (fobTypeId === 1886) {
        var e_1 = eventOdds["".concat(horseNo, "T2")];
        return (e_1 === null || e_1 === void 0 ? void 0 : e_1.win_odds) > 1 ? Number(e_1.win_odds).toFixed(2) : (e_1 === null || e_1 === void 0 ? void 0 : e_1.status) === 'o' ? 'KO' : '-';
    }
    if (fobTypeId === 1887) {
        var e_2 = eventOdds["".concat(horseNo, "T3")];
        return (e_2 === null || e_2 === void 0 ? void 0 : e_2.win_odds) > 1 ? Number(e_2.win_odds).toFixed(2) : (e_2 === null || e_2 === void 0 ? void 0 : e_2.status) === 'o' ? 'KO' : '-';
    }
    if (fobTypeId === 1888) {
        var e_3 = eventOdds["".concat(horseNo, "T4")];
        return (e_3 === null || e_3 === void 0 ? void 0 : e_3.win_odds) > 1 ? Number(e_3.win_odds).toFixed(2) : (e_3 === null || e_3 === void 0 ? void 0 : e_3.status) === 'o' ? 'KO' : '-';
    }
    if (fobTypeId === 1882) {
        var e_4 = eventOdds[Number(horseNo)];
        return (e_4 === null || e_4 === void 0 ? void 0 : e_4.status) === 'o' ? 'KO' : 'Kapanış';
    }
    var e = eventOdds[Number(horseNo)];
    return (e === null || e === void 0 ? void 0 : e.win_odds) > 1 ? Number(e.win_odds).toFixed(2) : (e === null || e === void 0 ? void 0 : e.status) === 'o' ? 'KO' : '-';
}
function groupNonKombine(items) {
    var groups = items.reduce(function (acc, item) {
        var key = "".concat(item.hippodrome.id, "__").concat(item.bettingType.id, "__").concat(item.run.no);
        if (!acc[key])
            acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {});
    // İkili/Sıralı İkili çiftlerinde "1. At/2. At" ve oddId araması column'a
    // göre sıralanmış sıraya dayanıyor (1884'te küçük numara, 1885'te seçim sırası).
    Object.values(groups).forEach(function (arr) { return arr.sort(function (a, b) { return a.column - b.column; }); });
    return groups;
}
export function TjkFobBetSlip() {
    var _a;
    var width = window.innerWidth;
    var isMobile = width < 986;
    var navigate = useNavigate();
    var forceUpdate = useForceUpdate();
    useEffect(function () {
        fobBetSlipToggle = width >= 986;
        var sub = tjkBetSlipVisibleSubject.subscribe(function (res) {
            if (res === 'close') {
                fobBetSlipToggle = false;
            }
            else {
                fobBetSlipToggle = !fobBetSlipToggle;
            }
            forceUpdate();
        });
        return function () {
            fobBetSlipToggle = false;
            sub.unsubscribe();
        };
    }, []);
    useEffect(function () {
        forceUpdate();
        var sub = tjkBetSlipActionSubject.subscribe(function () {
            forceUpdate();
        });
        return function () {
            sub.unsubscribe();
        };
    }, []);
    if (!tjkBetSlipOptions.hippodrome ||
        !tjkBetSlipOptions.bettingType ||
        !tjkBetSlipOptions.bettingSubType) {
        return _jsx(React.Fragment, {}, void 0);
    }
    var fobTypeId = Number(tjkBetSlipOptions.bettingType.id);
    if (!tjkFobBettingTypes.includes(fobTypeId))
        return _jsx(React.Fragment, {}, void 0);
    // Tüm FOB seçimleri — hippodrom/tür/koşu bağımsız
    var allFobItems = tjkBetslipStore.filter(function (el) {
        return tjkFobBettingTypes.includes(Number(el.bettingType.id));
    });
    var kombineItems = allFobItems.filter(function (el) { return Number(el.bettingType.id) === 1883; });
    var nonKombineItems = allFobItems.filter(function (el) { return Number(el.bettingType.id) !== 1883; });
    var nonKombineGroups = groupNonKombine(nonKombineItems);
    // Toplam bahis/tutar hesabı
    var totalBetCount = 0;
    var totalAmount = 0;
    if (kombineItems.length >= 2) {
        totalBetCount += 1;
        totalAmount += Number(kombineItems[0].bettingType.price || 0);
    }
    for (var _i = 0, _b = Object.values(nonKombineGroups); _i < _b.length; _i++) {
        var items = _b[_i];
        var typeId = Number(items[0].bettingType.id);
        var price = Number(items[0].bettingType.price || 0);
        if (tjkFobHorseSelectionTypes.includes(typeId)) {
            if (items.length >= 2) {
                totalBetCount += 1;
                totalAmount += price;
            }
        }
        else {
            totalBetCount += items.length;
            totalAmount += items.length * price;
        }
    }
    var getCombinedOdds = function () {
        return kombineItems.reduce(function (acc, item) {
            var _a, _b, _c;
            var odds = (_c = (_b = (_a = item.run) === null || _a === void 0 ? void 0 : _a.event_odds) === null || _b === void 0 ? void 0 : _b[Number(item.horse.no)]) === null || _c === void 0 ? void 0 : _c.win_odds;
            return odds > 1 ? acc * odds : acc;
        }, 1);
    };
    var getTotalOdds = function () {
        if (kombineItems.length >= 2) {
            var odds = getCombinedOdds();
            return odds > 1 ? odds.toFixed(2) : '-';
        }
        if (nonKombineItems.length > 0) {
            var total = 1;
            var hasOdds = false;
            for (var _i = 0, _a = Object.values(nonKombineGroups); _i < _a.length; _i++) {
                var items = _a[_i];
                var isExacta = items.length === 2;
                if (isExacta) {
                    var v = parseFloat(getGroupExactaOdds(items));
                    if (!isNaN(v) && v > 1) {
                        total *= v;
                        hasOdds = true;
                    }
                }
                else {
                    for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                        var item = items_1[_b];
                        var v = parseFloat(getOddsForItem(item));
                        if (!isNaN(v) && v > 1) {
                            total *= v;
                            hasOdds = true;
                        }
                    }
                }
            }
            return hasOdds ? total.toFixed(2) : '-';
        }
        return '-';
    };
    var getGroupExactaOdds = function (items) {
        if (items.length < 2)
            return '-';
        var typeId = Number(items[0].bettingType.id);
        var runNo = Number(String(items[0].bettingSubType).split('-')[0]);
        var run = items[0].hippodrome.runs.find(function (r) { return Number(r.no) === runNo; });
        var eventOdds = run === null || run === void 0 ? void 0 : run.event_odds;
        if (!eventOdds)
            return '-';
        var h1 = items[0].horse.no;
        var h2 = items[1].horse.no;
        var oddKey = typeId === 1885
            ? "".concat(h1, "-").concat(h2, "EX")
            : h1 > h2 ? "".concat(h2, "-").concat(h1) : "".concat(h1, "-").concat(h2);
        var e = eventOdds[oddKey];
        return (e === null || e === void 0 ? void 0 : e.win_odds) > 1 ? Number(e.win_odds).toFixed(2) : '-';
    };
    var removeItem = function (item) {
        var isKombineItem = Number(item.bettingType.id) === 1883;
        var idx = tjkBetslipStore.findIndex(function (el) {
            return el.hippodrome.id === item.hippodrome.id &&
                el.bettingType.id === item.bettingType.id &&
                (isKombineItem
                    ? el.run.no === item.run.no
                    : el.bettingSubType === item.bettingSubType) &&
                Number(el.horse.no) === Number(item.horse.no);
        });
        if (idx !== -1)
            tjkBetslipStore.splice(idx, 1);
        updateBetCount.status = true;
        tjkBetSlipActionSubject.next(null);
        forceUpdate();
    };
    var confirmCoupon = function () {
        var _a, _b, _c;
        if (totalBetCount === 0) {
            tjkBetSlipOptions.errorMessage = 'Kuponunuzda oynanacak bir bahis bulunmamaktadır.';
            forceUpdate();
            return;
        }
        if (isOverLimit) {
            tjkBetSlipOptions.errorMessage = "Toplam bahis tutar\u0131 ".concat(currencyFormat(maxCouponAmount), "\u20BA'yi ge\u00E7emez.");
            forceUpdate();
            return;
        }
        if (isOverMaxProfit) {
            tjkBetSlipOptions.errorMessage = "Maksimum kazan\u00E7 tutar\u0131 ".concat(currencyFormat(maxAllowedProfit), "\u20BA'den fazla olamaz.");
            forceUpdate();
            return;
        }
        if (member.id && (tjkBetSlipOptions.usePointBalance
            ? Number(member.debit_balance) + (member.point_balance / 100)
            : member.debit_balance) < couponAmount) {
            tjkBetSlipOptions.errorMessage = 'Bakiyeniz yetersiz.';
            forceUpdate();
            return;
        }
        // Modal içeriği: özet tablo + at listesi
        var isCombine = Object.entries(nonKombineGroups).length > 1;
        var hipLocation = isCombine ? 'Kombine' : ((_a = tjkBetSlipOptions.hippodrome) === null || _a === void 0 ? void 0 : _a.location) || '-';
        var betTypeName = isCombine ? 'Kombine Bahis' : ((_b = tjkBetSlipOptions.bettingType) === null || _b === void 0 ? void 0 : _b.name) || '-';
        var multiply = tjkBetSlipOptions.betSlipMultiply || 1;
        var buildHorseRow = function (item, idx, isSorted) {
            return "<div class=\"horse-no d-flex\" style=\"padding:4px 8px;border-bottom:1px solid var(--color-bg-light)\">\n                <div style=\"min-width:28px;font-weight:700;color:var(--color-primary)\">".concat(isSorted ? (idx + 1) + '.At' : item.horse.no, "</div>\n                <div style=\"flex:1\">").concat(isSorted ? item.horse.no + ' ' : '').concat(item.horse.name, "</div>\n                <div style=\"min-width:48px;text-align:right;font-weight:700;color:var(--color-success)\">").concat(getOddsForItem(item), "</div>\n            </div>");
        };
        var isSorted = tjkFobHorseSelectionTypes.includes(Number((_c = tjkBetSlipOptions.bettingType) === null || _c === void 0 ? void 0 : _c.id));
        var legsHtml = '';
        if (kombineItems.length > 0) {
            legsHtml += "<div style=\"margin-bottom:12px\">\n                <div class=\"run-no\" style=\"background:var(--color-primary);color:#fff;padding:6px 10px;font-weight:700;border-radius:4px 4px 0 0\">\n                    Kombine \u2014 ".concat(kombineItems.length, " Ayak\n                </div>\n                ").concat(kombineItems.map(function (item, idx) { return buildHorseRow(item, idx, false); }).join(''), "\n            </div>");
        }
        Object.entries(nonKombineGroups).forEach(function (_a) {
            var _b, _c, _d;
            var groupKey = _a[0], items = _a[1];
            var first = items[0];
            var typeName = ((_b = first.bettingType) === null || _b === void 0 ? void 0 : _b.name) || '-';
            var runNo = (_d = (_c = first.run) === null || _c === void 0 ? void 0 : _c.no) !== null && _d !== void 0 ? _d : '-';
            var isExacta = tjkFobHorseSelectionTypes.includes(Number(first.bettingType.id));
            legsHtml += "<div style=\"margin-bottom:12px\">\n                <div class=\"run-no\" style=\"background:var(--color-primary);color:#fff;padding:6px 10px;font-weight:700;border-radius:4px 4px 0 0\">\n                    ".concat(typeName, " \u2014 ").concat(runNo, ". Ko\u015Fu\n                </div>\n                ").concat(items.map(function (item, idx) { return buildHorseRow(item, idx, isExacta); }).join(''), "\n            </div>");
        });
        modalServiceSubject.next({
            title: "BAH\u0130S DETAYI",
            width: '600px',
            content: "\n                <table class=\"table table-striped table-bordered\" style=\"margin-bottom:16px\">\n                    <tbody>\n                        <tr>\n                            <th class=\"text-left\" style=\"width:110px\">Hipodrom</th>\n                            <td class=\"text-left\">".concat(hipLocation, "</td>\n                            <th class=\"text-left\" style=\"width:110px\">Bahis T\u00FCr\u00FC</th>\n                            <td class=\"text-left\">").concat(betTypeName, "</td>\n                        </tr>\n                        <tr>\n                            <th class=\"text-left\">Bahis Say\u0131s\u0131</th>\n                            <td class=\"text-left\">").concat(totalBetCount, "</td>\n                            <th class=\"text-left\">Misli</th>\n                            <td class=\"text-left\">").concat(multiply, "</td>\n                        </tr>\n                        <tr>\n                            <th class=\"text-left\">Kupon Bedeli</th>\n                            <td class=\"text-left\"><strong>").concat(currencyFormat(couponAmount), "\u20BA</strong></td>\n                            <th class=\"text-left\">Toplam Oran</th>\n                            <td class=\"text-left\"><strong>").concat(totalOddsStr, "</strong></td>\n                        </tr>\n                        <tr>\n                            <th class=\"text-left\">Max Kazan\u00E7</th>\n                            <td class=\"text-left\" colspan=\"3\"><strong style=\"color:var(--color-success)\">").concat(maxProfit > 0 ? currencyFormat(maxProfit) + '₺' : '-', "</strong></td>\n                        </tr>\n                    </tbody>\n                </table>\n                <div style=\"width:auto\">").concat(legsHtml, "</div>\n            "),
            confirm: {
                sure: {
                    class: 'btn-success',
                    label: 'Onayla',
                    action: function () { return playCoupon(false); },
                },
                cancel: { label: 'Vazgeç' },
            },
        });
    };
    var playCoupon = function (save) {
        if (save === void 0) { save = false; }
        tjkBetSlipOptions.inProgress = true;
        forceUpdate();
        PlayTjkFobCoupon(save).then(function (result) {
            var _a;
            var normalizedResult = Array.isArray(result)
                ? {
                    status: result.every(function (r) { return r && r.status === true; }),
                    isMultiFob: true,
                }
                : result;
            if ((normalizedResult === null || normalizedResult === void 0 ? void 0 : normalizedResult.status) === true && !save) {
                clearTjkBetSlip();
                modalServiceSubject.next({
                    title: 'Kuponunuz Oynandı',
                    content: 'Sabit ihtimalli kuponunuz başarıyla oynandı.',
                    confirm: {
                        sure: {
                            label: 'At Yarışı Kuponlarım',
                            action: function () { return navigate('/hesabim/tjk/devam-edenler'); },
                        },
                        cancel: { label: 'Yeni Kupon Oyna' },
                    },
                });
            }
            else if ((normalizedResult === null || normalizedResult === void 0 ? void 0 : normalizedResult.status) && save) {
                modalServiceSubject.next({
                    title: 'Kuponunuz Kaydedildi',
                    content: 'Sabit ihtimalli kuponunuz başarıyla kaydedildi.',
                    confirm: {
                        sure: {
                            label: 'Kayıtlı Kuponlarım',
                            action: function () { return navigate('/hesabim/tjk/kayitli'); },
                        },
                        cancel: { label: 'Yeni Kupon Oyna' },
                    },
                });
            }
            else if (!(normalizedResult === null || normalizedResult === void 0 ? void 0 : normalizedResult.isMultiFob) && normalizedResult) {
                var errData = (_a = normalizedResult.data) === null || _a === void 0 ? void 0 : _a.error;
                modalServiceSubject.next({
                    title: 'Hata',
                    content: (errData === null || errData === void 0 ? void 0 : errData.error_description) ||
                        (typeof normalizedResult.message === 'object'
                            ? JSON.stringify(normalizedResult.message)
                            : normalizedResult.message) ||
                        'Bir hata oluştu.',
                    confirm: { cancel: { label: 'Tamam' } },
                });
            }
            tjkBetSlipOptions.inProgress = false;
            forceUpdate();
        });
    };
    if (!fobBetSlipToggle)
        return _jsx(React.Fragment, {}, void 0);
    var emptyState = (_jsx("p", __assign({ style: {
            textAlign: 'center',
            fontSize: 12,
            color: 'var(--color-text-medium)',
            marginTop: 10,
            padding: '0 5px',
        } }, { children: "Bahis yapmak istedi\u011Finiz at\u0131 se\u00E7iniz." }), void 0));
    // --- Kombine (1883) bölümü ---
    var kombineSection = kombineItems.length > 0 && (_jsxs("div", __assign({ style: { marginBottom: 8 } }, { children: [_jsxs("div", __assign({ style: {
                    fontSize: 10,
                    fontWeight: 700,
                    color: 'var(--color-text-medium)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: 4,
                } }, { children: ["Kombine \u2014 ", kombineItems.length, " Ayak"] }), void 0), kombineItems.map(function (item, idx) {
                var _a, _b, _c;
                var odds = (_c = (_b = (_a = item.run) === null || _a === void 0 ? void 0 : _a.event_odds) === null || _b === void 0 ? void 0 : _b[Number(item.horse.no)]) === null || _c === void 0 ? void 0 : _c.win_odds;
                return (_jsxs("div", __assign({ style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 3,
                        fontSize: 12,
                        marginBottom: 3,
                        background: 'var(--color-bg-light)',
                        padding: '4px 6px',
                        borderRadius: 4,
                    } }, { children: [_jsxs("span", __assign({ style: {
                                color: 'var(--color-text-medium)',
                                minWidth: 16,
                                fontWeight: 600,
                            } }, { children: [idx + 1, "."] }), void 0), _jsx("span", __assign({ style: {
                                color: 'var(--color-text-medium)',
                                fontSize: 10,
                                minWidth: 42,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            } }, { children: item.hippodrome.location }), void 0), _jsxs("span", __assign({ style: { fontWeight: 600, minWidth: 22, fontSize: 11 } }, { children: [item.run.no, ".K"] }), void 0), _jsx("span", __assign({ style: { fontWeight: 700, minWidth: 14 } }, { children: item.horse.no }), void 0), _jsx("span", __assign({ style: {
                                flex: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            } }, { children: item.horse.name }), void 0), _jsx("span", __assign({ style: {
                                color: 'var(--color-success)',
                                fontWeight: 700,
                                minWidth: 34,
                                textAlign: 'right',
                            } }, { children: odds > 1 ? Number(odds).toFixed(2) : '-' }), void 0), _jsx("img", { src: Trash, width: 11, className: "cursor-pointer reinvert-color", style: { opacity: 0.5, marginLeft: 2 }, onClick: function () { return removeItem(item); } }, void 0)] }), idx));
            }), kombineItems.length >= 2 ? (_jsxs("div", __assign({ style: {
                    textAlign: 'center',
                    marginTop: 6,
                    fontSize: 12,
                    paddingTop: 5,
                    borderTop: '1px solid var(--color-bg-medium)',
                } }, { children: [_jsx("span", __assign({ style: { fontWeight: 600 } }, { children: "Kombine Oran: " }), void 0), _jsx("span", __assign({ style: {
                            color: 'var(--color-success)',
                            fontWeight: 700,
                            fontSize: 14,
                        } }, { children: getCombinedOdds().toFixed(2) }), void 0), kombineItems.length < 7 && (_jsxs("span", __assign({ style: {
                            fontSize: 10,
                            color: 'var(--color-text-medium)',
                            marginLeft: 6,
                        } }, { children: ["(", 7 - kombineItems.length, " hak kald\u0131)"] }), void 0))] }), void 0)) : (_jsx("p", __assign({ style: {
                    textAlign: 'center',
                    fontSize: 11,
                    color: 'var(--color-text-medium)',
                    margin: '4px 0 0',
                } }, { children: "En az 1 ko\u015Fu daha se\u00E7iniz" }), void 0))] }), void 0));
    // --- Non-kombine gruplar ---
    var nonKombineSections = Object.entries(nonKombineGroups).map(function (_a) {
        var key = _a[0], items = _a[1];
        var groupTypeId = Number(items[0].bettingType.id);
        var isExacta = tjkFobHorseSelectionTypes.includes(groupTypeId);
        var headerLabel = "".concat(items[0].hippodrome.location, " ").concat(items[0].run.no, ".Ko\u015Fu ").concat(items[0].bettingType.name);
        return (_jsxs("div", __assign({ style: { marginBottom: 8 } }, { children: [_jsx("div", __assign({ style: {
                        fontSize: 10,
                        fontWeight: 700,
                        color: 'var(--color-text-medium)',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        marginBottom: 4,
                    } }, { children: headerLabel }), void 0), isExacta ? (_jsxs("div", { children: [items.map(function (item, idx) { return (_jsxs("div", __assign({ style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 4,
                                fontSize: 12,
                                marginBottom: 3,
                                background: 'var(--color-bg-light)',
                                padding: '4px 6px',
                                borderRadius: 4,
                            } }, { children: [_jsxs("span", __assign({ style: {
                                        color: 'var(--color-text-medium)',
                                        fontSize: 11,
                                        minWidth: 22,
                                    } }, { children: [idx + 1, ". At"] }), void 0), _jsx("span", __assign({ style: { fontWeight: 700, minWidth: 14 } }, { children: item.horse.no }), void 0), _jsx("span", __assign({ style: {
                                        flex: 1,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    } }, { children: item.horse.name }), void 0), _jsx("img", { src: Trash, width: 11, className: "cursor-pointer reinvert-color", style: { opacity: 0.5 }, onClick: function () { return removeItem(item); } }, void 0)] }), idx)); }), items.length === 2 && (_jsxs("div", __assign({ style: { textAlign: 'center', marginTop: 5, fontSize: 12 } }, { children: [_jsx("span", __assign({ style: { fontWeight: 600 } }, { children: "Oran: " }), void 0), _jsx("span", __assign({ style: { color: 'var(--color-success)', fontWeight: 700 } }, { children: getGroupExactaOdds(items) }), void 0)] }), void 0)), items.length === 1 && (_jsx("p", __assign({ style: {
                                textAlign: 'center',
                                fontSize: 11,
                                color: 'var(--color-text-medium)',
                                margin: '4px 0 0',
                            } }, { children: "2. at\u0131 se\u00E7iniz" }), void 0))] }, void 0)) : (_jsx("table", __assign({ style: {
                        width: '100%',
                        fontSize: 12,
                        borderCollapse: 'collapse',
                    } }, { children: _jsx("tbody", { children: items.map(function (item, idx) { return (_jsxs("tr", __assign({ style: { borderBottom: '1px solid var(--color-bg-light)' } }, { children: [_jsx("td", __assign({ style: { padding: '3px 0', fontWeight: 700, width: 18 } }, { children: item.horse.no }), void 0), _jsx("td", __assign({ style: {
                                        padding: '3px 4px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        maxWidth: 70,
                                    } }, { children: item.horse.name }), void 0), _jsx("td", __assign({ style: {
                                        padding: '3px 0',
                                        textAlign: 'right',
                                        color: 'var(--color-success)',
                                        fontWeight: 700,
                                    } }, { children: getOddsForItem(item) }), void 0), _jsx("td", __assign({ style: { padding: '3px 0 3px 5px', width: 16 } }, { children: _jsx("img", { src: Trash, width: 12, className: "cursor-pointer reinvert-color", style: { display: 'block', opacity: 0.5 }, onClick: function () { return removeItem(item); } }, void 0) }), void 0)] }), idx)); }) }, void 0) }), void 0))] }), key));
    });
    var hasContent = allFobItems.length > 0;
    var bodyContent = !hasContent ? (emptyState) : (_jsxs("div", { children: [kombineSection, nonKombineSections.length > 0 && kombineItems.length > 0 && (_jsx("div", { style: {
                    borderTop: '1px solid var(--color-bg-medium)',
                    marginBottom: 8,
                } }, void 0)), nonKombineSections] }, void 0));
    var multiplyChoices = Array.from({ length: 100 }, function (_, i) { return i + 1; });
    var betSlipMultiply = Number(tjkBetSlipOptions.betSlipMultiply) || 1;
    var couponAmount = Number(betSlipMultiply);
    var maxCouponAmount = ((_a = tjkBetSlipOptions.bettingType) === null || _a === void 0 ? void 0 : _a.maxCouponAmount) || 12000;
    var isOverLimit = couponAmount > maxCouponAmount;
    var totalOddsStr = getTotalOdds();
    var totalOddsNumeric = parseFloat(totalOddsStr);
    var maxProfit = !isNaN(totalOddsNumeric) && totalOddsNumeric > 0
        ? couponAmount * totalOddsNumeric
        : 0;
    var maxAllowedProfit = 7500000;
    var isOverMaxProfit = maxProfit > maxAllowedProfit;
    var canPlay = totalBetCount > 0 && !isOverLimit && !isOverMaxProfit && !tjkBetSlipOptions.inProgress;
    var footerSection = (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "footer-row" }, { children: _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("div", __assign({ className: "fw-bold misli-label" }, { children: "Misli:" }), void 0), _jsx("input", { className: "select betslip-input", type: "number", pattern: "^[0-9\\b]+$", min: 1, step: 1, value: tjkBetSlipOptions.betSlipMultiply || '', onChange: function (e) { return setTjkBetSlipMultiply(e.target.value); }, onBlur: function () {
                                if (tjkBetSlipOptions.betSlipMultiply === '') {
                                    setTjkBetSlipMultiply(1);
                                }
                            }, onPaste: function (e) {
                                e.preventDefault();
                                return false;
                            } }, void 0), _jsx("select", __assign({ className: "betslip-select", value: betSlipMultiply, onChange: function (e) { return setTjkBetSlipMultiply(e.target.value); } }, { children: multiplyChoices.map(function (el, key) { return (_jsx("option", __assign({ value: el }, { children: el }), key)); }) }), void 0)] }), void 0) }), void 0), _jsxs("div", __assign({ className: "fob-betslip-stats m-2" }, { children: [_jsxs("div", __assign({ className: "fob-betslip-stats-row" }, { children: [_jsx("span", { children: "Kupon Bedeli" }, void 0), _jsxs("span", __assign({ className: "fw-bold".concat(isOverLimit ? ' fob-betslip-over-limit' : '') }, { children: [currencyFormat(couponAmount), "\u20BA"] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "fob-betslip-stats-row" }, { children: [_jsx("span", { children: "Toplam Oran" }, void 0), _jsx("span", __assign({ className: "fw-bold" }, { children: totalOddsStr }), void 0)] }), void 0), _jsxs("div", __assign({ className: "fob-betslip-stats-row" }, { children: [_jsx("span", { children: "Max Kazan\u00E7" }, void 0), _jsx("span", __assign({ className: "fw-bold".concat(isOverMaxProfit ? ' fob-betslip-over-limit' : ' fob-betslip-profit') }, { children: maxProfit > 0 ? currencyFormat(maxProfit) + '₺' : '-' }), void 0)] }), void 0), isOverLimit && (_jsxs("div", __assign({ className: "fob-betslip-limit-warning" }, { children: ["Toplam bahis tutar\u0131 ", currencyFormat(maxCouponAmount), "\u20BA'yi ge\u00E7emez."] }), void 0)), isOverMaxProfit && (_jsxs("div", __assign({ className: "fob-betslip-limit-warning" }, { children: ["Maksimum kazan\u00E7 tutar\u0131 ", currencyFormat(maxAllowedProfit), "\u20BA'den fazla olamaz."] }), void 0))] }), void 0), member.id && (_jsx("div", __assign({ className: "footer-row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "select" }, { children: [_jsx("div", __assign({ className: "fw-bold" }, { children: "Puan Kullan:" }), void 0), _jsx("input", { type: "checkbox", checked: tjkBetSlipOptions.usePointBalance, onChange: function () { return setTjkUsePointBalance(!tjkBetSlipOptions.usePointBalance); } }, void 0), member ? (member.point_balance / 100).toFixed(2) + '₺' : '0.00₺'] }), void 0) }), void 0) }), void 0)), _jsxs("div", __assign({ className: "footer-row betslip-footer" }, { children: [tjkBetSlipOptions.errorMessage && (_jsx("div", __assign({ className: "w-100 alert-danger mb-1" }, { children: tjkBetSlipOptions.errorMessage }), void 0)), _jsx("div", __assign({ className: "w-25 pr-1" }, { children: _jsx("button", __assign({ onClick: function () {
                                clearTjkBetSlip();
                                forceUpdate();
                            }, className: "btn btn-warning w-100 m-0" }, { children: _jsx("img", { src: Trash, width: 16, height: 16 }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "w-25 pl-1 pr-1" }, { children: _jsx("button", __assign({ onClick: function () { return playCoupon(true); }, className: "btn w-100 m-0" }, { children: _jsx("img", { src: Save, width: 16, height: 16 }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "w-50 pl-1" }, { children: _jsx("button", __assign({ onClick: function () { return confirmCoupon(); }, disabled: !canPlay, className: "btn btn-primary w-100 m-0" }, { children: "Oyna" }), void 0) }), void 0)] }), void 0)] }, void 0));
    if (isMobile) {
        var hasError = isOverLimit || isOverMaxProfit || !!tjkBetSlipOptions.errorMessage;
        var errorMsg = isOverLimit
            ? "Toplam bahis tutar\u0131 ".concat(currencyFormat(maxCouponAmount), "\u20BA'yi ge\u00E7emez.")
            : isOverMaxProfit
                ? "Maks. kazan\u00E7 ".concat(currencyFormat(maxAllowedProfit), "\u20BA'den fazla olamaz.")
                : tjkBetSlipOptions.errorMessage;
        return (_jsxs("div", __assign({ className: "fob-mobile-bar" }, { children: [_jsx("button", __assign({ className: "fob-mobile-close", onClick: function () { return tjkBetSlipVisibleSubject.next('close'); } }, { children: "\u00D7" }), void 0), _jsxs("div", __assign({ className: "fob-mobile-content" }, { children: [hasError && (_jsx("div", __assign({ className: "fob-mobile-error-row" }, { children: errorMsg }), void 0)), _jsxs("div", __assign({ className: "fob-mobile-info-row" }, { children: [_jsxs("div", __assign({ className: "fob-mobile-info-item" }, { children: [_jsx("span", { children: "T. Oran" }, void 0), _jsx("span", __assign({ className: "fw-bold" }, { children: totalOddsStr }), void 0)] }), void 0), _jsxs("div", __assign({ className: "fob-mobile-info-item fob-mobile-info-sep" }, { children: [_jsx("span", { children: "Puan" }, void 0), _jsx("span", { children: member.id ? (member.point_balance / 100).toFixed(2) + '₺' : '-' }, void 0), member.id && (_jsx("button", { className: "fob-mobile-checkbox".concat(tjkBetSlipOptions.usePointBalance ? ' checked' : ''), onClick: function () { return setTjkUsePointBalance(!tjkBetSlipOptions.usePointBalance); } }, void 0))] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "fob-mobile-actions-row" }, { children: [_jsx("button", __assign({ className: "fob-mobile-btn fob-mobile-btn-icon", onClick: function () {
                                        clearTjkBetSlip();
                                        forceUpdate();
                                    } }, { children: _jsx("img", { src: Trash, width: 16, height: 16, className: "reinvert-color", alt: "" }, void 0) }), void 0), _jsx("button", __assign({ className: "fob-mobile-btn fob-mobile-btn-icon", onClick: function () { return playCoupon(true); } }, { children: _jsx("img", { src: Save, width: 16, height: 16, className: "reinvert-color", alt: "" }, void 0) }), void 0), _jsxs("div", __assign({ className: "fob-mobile-misli" }, { children: [_jsx("span", __assign({ className: "fob-mobile-misli-label" }, { children: "Misli" }), void 0), _jsx("input", { type: "number", pattern: "^[0-9\\b]+$", className: "fob-mobile-misli-input", value: tjkBetSlipOptions.betSlipMultiply || '', min: 1, onChange: function (e) { return setTjkBetSlipMultiply(e.target.value); }, onBlur: function () {
                                                if (!tjkBetSlipOptions.betSlipMultiply)
                                                    setTjkBetSlipMultiply(1);
                                            }, onPaste: function (e) {
                                                e.preventDefault();
                                                return false;
                                            } }, void 0)] }), void 0), _jsxs("button", __assign({ className: "fob-mobile-btn fob-mobile-btn-play".concat(canPlay ? ' active' : ''), disabled: !canPlay, onClick: function () { return navigate('/at-yarisi/tjk-bilet-onay/'); } }, { children: [_jsx("span", __assign({ className: "fob-mobile-btn-play-label" }, { children: "OYNA" }), void 0), _jsxs("span", __assign({ className: "fw-bold fob-mobile-btn-play-amount" }, { children: [currencyFormat(couponAmount), "\u20BA"] }), void 0)] }), void 0)] }), void 0)] }), void 0)] }), void 0));
    }
    return (_jsx(React.Fragment, { children: _jsxs("div", __assign({ className: "card tjk-betslip float-left" }, { children: [tjkBetSlipOptions.inProgress && (_jsxs("div", __assign({ className: "betslip-overlay" }, { children: [_jsxs("div", __assign({ className: "lds-roller" }, { children: [_jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0)] }), void 0), _jsx("div", __assign({ className: "text-center mt-3" }, { children: "\u0130\u015Fleminiz devam ediyor." }), void 0)] }), void 0)), _jsx("div", __assign({ className: "card-title p-2" }, { children: _jsx("h5", __assign({ className: "text-white" }, { children: "Sabit \u0130htimalli Bahis Kuponu" }), void 0) }), void 0), _jsx("div", __assign({ className: "card-body pl-2 pt-2 pb-2 pr-1" }, { children: bodyContent }), void 0), _jsx("div", __assign({ className: "card-footer" }, { children: footerSection }), void 0)] }), void 0) }, void 0));
}
